import { Capacitor } from '@capacitor/core';
import { Clipboard } from '@capacitor/clipboard';

const writeWithWebFallback = async (text: string): Promise<void> => {
  if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(text);
    return;
  }

  const textArea = document.createElement('textarea');
  textArea.value = text;
  textArea.setAttribute('readonly', '');
  textArea.style.position = 'fixed';
  textArea.style.left = '-9999px';
  textArea.style.top = '0';
  document.body.appendChild(textArea);
  textArea.focus();
  textArea.select();

  try {
    if (!document.execCommand('copy')) {
      throw new Error('Clipboard copy command failed');
    }
  } finally {
    document.body.removeChild(textArea);
  }
};

export const writeClipboardText = async (text: string): Promise<void> => {
  if (Capacitor.isNativePlatform()) {
    await Clipboard.write({ string: text });
    return;
  }

  await writeWithWebFallback(text);
};

export const readClipboardText = async (): Promise<string> => {
  if (Capacitor.isNativePlatform()) {
    const result = await Clipboard.read();
    return result.value ?? '';
  }

  if (typeof navigator !== 'undefined' && navigator.clipboard?.readText) {
    return navigator.clipboard.readText();
  }

  throw new Error('Clipboard read is not available on this device');
};
